<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div class="content-1">
        <div v-if="loadingStarted">
          <loading></loading>
        </div>
        <div v-else-if="loadingSuccessful">
          <div>
            <div class="font-secondary study-info-heading">Study Information</div>
            <div class="study-info-name">
              <h4 class="header-tags font-secondary">{{surveyName}}</h4>
              <h5 class="header-tags font-secondary">Study ID: {{surveyID}}</h5>
              <p class="study-status header-tags">{{status}}</p>
            </div>
            <div class="study-info-contact">
              <div>{{dateCreate}}</div>
              <div v-if="authorNameIsPublic">{{authorName}}</div>
              <div v-if="authorEmailIsPublic">{{authorEmail}}</div>
              <div>{{country}}</div>
            </div>
            <StudyInfo></StudyInfo>
            <div class="study-info-buttons">
              <router-link v-if="userHasBoughtStudy" class="study-buy-button" :to="myPurchasesRoute">
                <a class="font-secondary">View Purchases</a>
              </router-link>
              <div v-else class="study-buy-button" v-on:click="openHandler">
                <a  class="font-secondary">Buy Complete Results</a>
              </div>
              <router-link class="study-view-button" :to="flashResultsRoute">
                <a class="font-secondary">View Flash Results</a>
              </router-link>
            </div>
          </div>
          <div v-if="modalShowState">
            <Modal>
              <div class="confirm-delete-study-dialog pdng-1">
                <div>
                  <div class="exit-row">
                    <Fai :icon="['fal', 'times']" @click="closeModal()"/>
                  </div>
                  <div class="pdng-1">
                    <div class="prompt-row">
                      <span v-if="modalLoadedSuccessfully">Thank you for your purchase. The study data will be sent to your email and available in the dashboard</span>
                      <span v-else-if="modalFailedToLoad">Something went wrong.  Your credit card has not been charged</span>
                      <span v-else-if="modalStillLoading">Please wait while we process your card</span>
                    </div>
                    <div class="actions-row pdng-1 top">
                      <div class="action">
                        <span v-if="modalStillLoading">
                            <Loading></Loading>
                        </span>
                        <button v-else type="button" class="pure-button bigmi-wide-button bigmi-cyan-blue-2-button"
                                @click="closeModal()">
                          <span v-if="modalLoadedSuccessfully">CONTINUE</span>
                          <span v-else-if="modalFailedToLoad">BACK</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
        <div v-else-if="loadingFailed">
          <div class="centered-row">
            <ErrorPage>
              <div slot="header">ERROR</div>
              <div slot="message">Sorry, there was an error loading the page</div>
            </ErrorPage>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import http from "../../services/axios"
  import {formatDate} from '../../services/utilities'
  import ErrorPage from "./ErrorPage"

  import {
    GET_BACKEND_URL,
    GET_HTTP_CONFIG,
    GET_IS_LOGGED_IN,
    GET_STRIPE_STANDARD_KEY,
    INSTANTIATE_CHECKOUT,
    LOAD_PUBLIC_STUDY_INFO, LOAD_PURCHASES_OF_USER,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_PRISTINE,
    LOADING_STARTED,
    R_NAME_BUY_STUDY,
    R_NAME_FLASH_RESULTS, R_NAME_PURCHASES,
    SET_CHECKOUT_SCRIPT_TAG_STATE,
    SET_LOGIN_DROPDOWN_STATE,
    SET_LOGIN_REDIRECT
  } from "../../services/constants"
  import StudyInfo from "./StudyInfo"

    export default {
      name: "PublicStudy",
      components: {StudyInfo, ErrorPage},
      created() {
        this.$store.dispatch(LOAD_PUBLIC_STUDY_INFO, this.$route.params.study_id).then(response => {
            let handler = this.createHandler()
            return this.$store.dispatch(INSTANTIATE_CHECKOUT, handler)
        })
      },

      methods:{
        openHandler(){
          if(this.isLoggedIn){
            this.checkoutInstance.open({
              name: `Study: ${this.study.surveyParamaters.name}`,
              description: this.labels,
              zipCode: true,
              amount: 25000
            })
          }
          else{
            this.openLoginDropdown()
          }
        },
        createHandler(){
          return {
            key: this.$store.getters[GET_STRIPE_STANDARD_KEY],
            image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
            locale: 'auto',
            token: (token) => {
              this.modalLoading()

              let postBody = {
                stripeToken : token.id,
                email : token.email
              }

              return http.post(this.$store.getters[GET_BACKEND_URL](`studies/${this.study.id}/purchase/full`), postBody, this.$store.getters[GET_HTTP_CONFIG])
                .then(response => {
                  this.$store.dispatch(LOAD_PURCHASES_OF_USER)
                  response.data.success ? this.modalSucceeded() : this.modalFailure()
                })
                .catch(err => {
                  this.modalFailure()
                })
            }
          }
        },
        closeModal(){
          this.modalShowState = false
        },
        modalSucceeded(){
          this.modalStatus = LOADING_COMPLETED_SUCCESS
          this.modalShowState = true
        },
        modalFailure(){
          this.modalStatus = LOADING_COMPLETED_FAILURE
          this.modalShowState = true
        },
        modalLoading(){
          this.modalStatus = LOADING_STARTED
          this.modalShowState = true
        },
        openLoginDropdown(){
          this.$store.commit(SET_LOGIN_REDIRECT, Object.assign({}, this.$route))
          this.$store.commit(SET_LOGIN_DROPDOWN_STATE, true)
        }
      },

      data(){
        return{
          modalShowState: false,
          modalStatus: LOADING_PRISTINE
        }
      },

      computed: {
        loadingStatus(){
          return this.$store.state.dataModule.publicStudyInfo.loadingState
        },
        study(){
          return this.$store.state.dataModule.publicStudyInfo.data
        },
        surveyName(){
          return this.study.surveyParamaters.name
        },
        checkoutInstance() {
          return this.$store.state.paymentModule.checkoutObj
        },
        modalLoadedSuccessfully() {
          return this.modalStatus === LOADING_COMPLETED_SUCCESS
        },
        modalFailedToLoad() {
          return this.modalStatus === LOADING_COMPLETED_FAILURE
        },
        modalStillLoading() {
          return this.modalStatus === LOADING_STARTED
        },
        surveyID(){
          return this.study.label
        },
        loadingStarted(){
          return this.loadingStatus === LOADING_STARTED
        },
        loadingSuccessful(){
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        loadingFailed(){
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
        status(){
          let dateClosed = this.study.dateClosed ? this.dateClose : ''
          return this.study.active ? 'Status: Open' : `Status: Closed ${dateClosed}`
        },
        dateClose(){
          let date = new Date(this.study.dateClosed)
          let formattedBirthday = formatDate(date)
          return formattedBirthday
        },
        dateCreate(){
          let date = new Date(this.study.dateCreated)
          let formattedBirthday = formatDate(date)
          return `Created ${formattedBirthday}`
        },
        studyInfo(){
          return this.study.surveyParamaters.studyInfo
        },
        studyPurpose(){
          return this.study.studyPurpose
        },
        getRatingQuestion(){
          return this.study.surveyParamaters.ratingQuestions[0].ratingQuestion
        },
        labels(){
          return this.study.tags.map(tag => tag['keyword']).join(', ')
        },
        getSegmentQuestion(){
          return `${this.study.surveyParamaters.segmentQuestions[0].question} Given the following choices:`
        },
        getSegmentQuestionAnswers(){
          return this.study.surveyParamaters.segmentQuestions[0].answers.join(', ')
        },
        buyButtonRoute(){
          return { name: R_NAME_BUY_STUDY }
        },
        flashResultsRoute(){
          return { name: R_NAME_FLASH_RESULTS, params:{id: `${this.$route.params.study_id}`} }
        },
        myPurchasesRoute(){
          return { name: R_NAME_PURCHASES }
        },
        getRatingScale(){
          let low = this.study.surveyParamaters.ratingQuestions[0].lowEnd
          let high = this.study.surveyParamaters.ratingQuestions[0].highEnd
          let maxRating = this.study.surveyParamaters.maxRating
          return `asked to respond with a number between 1 and ${maxRating} (1 is ${low}, ${maxRating} is ${high})`
        },
        country(){
          return `Country: ${this.study.author.country}`
        },
        authorNameIsPublic(){
          return "name" in this.study.author
        },
        authorName(){
          return `By: ${this.study.author.name}`
        },
        authorEmailIsPublic(){
          return "email" in this.study.author
        },
        authorEmail(){
          return `Contact: ${this.study.author.email}`
        },
        isLoggedIn() {
          return this.$store.getters[GET_IS_LOGGED_IN]
        },
        userHasBoughtStudy(){
          return this.$store.state.dataModule.purchases.data.some(purchase => {
            return purchase.study.id === parseInt(this.$route.params.study_id)  && purchase.type === 'full'
          })
        }
      }

    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .content-1 {
    margin: 0 60px;
  }

  .study-info-heading{
    color: $red-2;
    font-size: 17px;
    font-weight: bold;
    line-height: 19px;
    margin-top: 45px;
  }

  .study-info-name{
    margin-right: 60px;
    margin-top: 35px;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 10px;
    color: $cyan-blue-3;
    font-size: 14px;
    font-weight: bold;
    line-height: 17px;
    background: $yellow-green-1;
  }

  .study-status{
    color: $cyan-1;
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 12px;
  }

  .header-tags{
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
  }

  .study-info-contact {
    color: $cyan-1;
    font-size: 14px;
    line-height: 17px;
    margin-top: 6px;
  }

  .study-info-subhead {
    color: $cyan-blue-3;
    font-size: 14px;
    font-weight: bold;
    line-height: 17px;
    border-bottom: 1px solid $gray-2;
    margin-right: 60px;
    margin-top: 20px;
    padding-left: 5px;
    padding-bottom: 1px;
  }

  .study-info-content {
    color: $cyan-1;
    font-size: 14px;
    line-height: 17px;
    margin-top: 4px;
  }

  .study-info-buttons {
    margin-top: 40px;
    margin-bottom: 120px;
    display: flex;
    @media #{$mobile} {
      flex-direction: column;
    }
  }

  .study-buy-button {
    text-decoration: none;
    padding: 8px 18px;
    border: 2px solid $red-2;
    border-radius: 3px;
    color: $white-1;
    font-size: 13px;
    font-weight: bold;
    line-height: 15px;
    text-align: center;
    background: $red-2;
    margin-right: 5px;
    cursor: pointer;
    @media #{$mobile} {
      margin: 5px 0;
    }
  }

  .study-view-button {
    text-decoration: none;
    padding: 8px 18px;
    border: 2px solid #273136;
    border-radius: 3px;
    color: $cyan-1;
    font-size: 13px;
    font-weight: bold;
    line-height: 15px;
    text-align: center;
    @media #{$mobile} {
      margin: 5px 0;
    }
  }

  .capitalize{
    text-transform:capitalize;
  }

  .confirm-delete-study-dialog {
    background-color: $white-1;
    border-radius: 5px;

    .exit-row {
      display: flex;
      justify-content: flex-end;
    }

    .actions-row {
      display: flex;
      justify-content: center;
      .action {

      }
    }
  }


</style>
